<span class="benefit">
  <i class="fa-icon d-inline-block me-2" [innerHTML]="svg | bypassSecurityTrust : 'html'"></i>
  <span *ngIf="language != 'en'" [innerHtml]="name"></span>
  <span *ngIf="language == 'en'" [innerHtml]="name_en"></span>
</span>
